import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { FilterSelectOrClear } from '@calendly/ui/components/dropdown';
import { SimplePopup } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { differenceBy, flatMap, uniqBy } from 'lodash-es';
import { forwardRef } from 'react';
import { Layout } from 'components/layout';
import { useEventType, useEventTypeContext } from 'features/event_type_provider';
import { useApplyTo } from './hooks';
import { SearchResults } from './search_results';
import { EventTypeMarker } from './styles';
import { useSearchForEventTypesV4 } from './use_search_for_event_types';
const Controls = props => <Layout paddingX="16" gap="8" direction="column" {...props} />;
const getAllEventTypes = results => flatMap(results, ({
  eventTypes
}) => eventTypes || []);
export const CopyToContent = ({
  selectedETs,
  setSelectedETs,
  userId
}) => {
  const {
    eventType,
    isCreation
  } = useEventTypeContext();
  const [SearchInput, query, results, isLoading, fetchMore, isLoadingMore] = useSearchForEventTypesV4({
    eventTypeId: eventType.id,
    filterLocked: true,
    userId,
    addEditInfo: true
  });
  const handleSelection = et => {
    const isAlreadySelected = selectedETs.find(({
      id
    }) => String(et.id) === String(id));
    if (isAlreadySelected) {
      setSelectedETs(selectedETs.filter(({
        id
      }) => String(et.id) !== String(id)));
    } else {
      setSelectedETs([...selectedETs, et]);
    }
  };
  const handleOnClear = () => setSelectedETs(differenceBy(selectedETs, getAllEventTypes(results), 'id'));
  const handleOnSelectAll = () => setSelectedETs(uniqBy([...selectedETs, ...getAllEventTypes(results)], 'id'));
  if (isCreation) {
    return <Controls>
        <ContextualBanner variant="subtle">
          {I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.copy_from_to.not_available_during_creation')}
        </ContextualBanner>
      </Controls>;
  }
  return <>
      <Controls>
        {SearchInput}
        <FilterSelectOrClear onClear={handleOnClear} onSelectAll={handleOnSelectAll} />
      </Controls>
      <div>
        <SearchResults isLoading={isLoading} query={query} results={results} handleSelection={handleSelection} selectedETs={selectedETs} itemType="copy-to" fetchMore={fetchMore} isLoadingMore={isLoadingMore} />
      </div>
    </>;
};
const sheetCss = "s19xzixi";
const Sheet = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sheetCss, props.className)} />;
});
const EventTypesContainer = ({
  children
}) => <Sheet><Layout direction="column" gap="16" padding="16">{children}</Layout></Sheet>;
const EventTypeItem = ({
  color,
  name
}) => <Layout gap="12" direction="column">
    <Layout gap="8" align="baseline">
      <EventTypeMarker color={color} />
      {name}
    </Layout>
  </Layout>;
const BodyLayout = props => <Layout direction="column" gap="12" {...props} />;
export const CopyToPopup = ({
  onClose,
  selectedETs,
  toggleDropdown,
  userId
}) => {
  const eventType = useEventType();
  const {
    apply,
    isLoading
  } = useApplyTo({
    toggleDropdown,
    selectedETs
  });
  const handleApply = () => {
    apply({
      userId,
      sourceEventTypeId: eventType.id,
      eventTypeIds: selectedETs.map(({
        id
      }) => id)
    });
  };
  return <SimplePopup cancelLabel={I18n.t('publisher.action.cancel')} confirmLabel={I18n.t('publisher.action.apply')} onClose={onClose} onConfirm={handleApply} isLoading={isLoading} title={I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.copy_from_to.to_popup_title', {
    count: selectedETs.length
  })}>
      <BodyLayout>
        <p>
          {HtmlParser(I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.copy_from_to.to_popup_line_1', {
          count: selectedETs.length
        }))}
        </p>
        <EventTypesContainer>
          {selectedETs.map(({
          id,
          color,
          name
        }) => <EventTypeItem key={id} color={color} name={name} />)}
        </EventTypesContainer>
        <p>{I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.copy_from_to.to_popup_line_2')}</p>
      </BodyLayout>
    </SimplePopup>;
};

require("./copy_to.wyw-in-js.css!=!../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./copy_to.js");